import {Component, OnInit} from "@angular/core";
import {HaushaltStepComponent} from "./haushalt.step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {StancheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {StancheckBackendService} from "../services/backend.service";
import {PortalService} from "../../services/portal.service";

@Component({
    selector: 'app-stancheck-gebaeude-ergebnis',
    templateUrl: './haushalt.ergebnis.component.html',
    standalone: false
})
export class HaushaltErgebnisComponent extends HaushaltStepComponent implements OnInit {
  protected loadingData: boolean = false;
  constructor(
    protected stepService: StepService,
    protected router: Router,
    protected requestService: StancheckRequestService,
    protected elementService: ElementService,
    protected backendService: StancheckBackendService,
    protected portalService: PortalService,
  ) {
    super(stepService, router, requestService, elementService);
  }
  ngOnInit() {
    super.ngOnInit();
  }

  onSubmit(): void {
    this.calculateResults();
  }

  private calculateResults(): void {
    this.loadingData = true;
    this.backendService.getRequestId().subscribe(requestId => {
      // calculate result
      this.backendService.result(this.anfrage, requestId).subscribe(data => {
        this.loadingData = false;
        this.anfrage.result = data;
        this.requestService.setAnfrage(this.anfrage);
        this.router.navigateByUrl(this.portalService.currentPortalId + '/stancheck/ergebnis/analyse');
      }, error => {
        this.loadingData = false;
        // generic error, mostly on the connection to the backend.
        this.formError = 'connection';
        console.error("Could not get data from backend", error);
        this.elementService.scrollToElement(this.stepForm.nativeElement);
      });
    }, error => {
      this.loadingData = false;
      // an error occured while talking to the backend.
      console.error("Could not get requestid from backend", error);
    });
  }
}
